import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { useIntl } from 'react-intl';
import './order-print-copy.scss';
import cmsFetch from '~/helpers/cms-fetch';
function Header({ entry }) {
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FontAwesomeIcon, { icon: entry.headerIcon }),
            entry.headerText)));
}
function PhoneBox({ entry }) {
    return (React.createElement("a", { className: "box", href: entry.buttonUrl, "data-track": "Print" },
        React.createElement(Header, { entry: entry })));
}
function PhoneBoxes({ contentArray }) {
    return (React.createElement("div", { className: `phone-version boxes boxes-${contentArray.length}` }, contentArray.map((entry) => (React.createElement(PhoneBox, { entry, key: entry.headerText })))));
}
function Button({ href, text, buttonClass }) {
    return (React.createElement("a", { className: `btn ${buttonClass}`, href: href, "data-track": "Print" }, text));
}
function DesktopBox({ index, entry }) {
    const buttonClass = ['primary', 'secondary'][index];
    return (React.createElement("div", { className: "box", key: entry.headerText },
        React.createElement(Header, { entry: entry }),
        React.createElement(Button, { buttonClass: buttonClass, href: entry.buttonUrl, text: entry.buttonText })));
}
function DesktopBoxes({ contentArray }) {
    return (React.createElement("div", { className: `larger-version boxes boxes-${contentArray.length}` }, contentArray.map((entry, index) => (React.createElement(DesktopBox, { index, entry, key: entry.headerText })))));
}
function useBookstoreContentLink(slug) {
    const [url, setUrl] = React.useState(null);
    React.useEffect(() => {
        cmsFetch(slug).then((data) => setUrl(data.amazon_link));
    }, [slug]);
    return url;
}
export default function OrderPrintCopy({ slug }) {
    const { formatMessage } = useIntl();
    const bookstoreLink = useBookstoreContentLink(slug);
    const contentArray = React.useMemo(() => {
        if (!bookstoreLink) {
            return null;
        }
        const individual = formatMessage({
            id: 'printcopy.individual',
            defaultMessage: 'Individual'
        });
        const button1Text = formatMessage({
            id: 'printcopy.button1',
            defaultMessage: 'Buy a print copy'
        });
        const bookstore = formatMessage({
            id: 'printcopy.bookstore',
            defaultMessage: 'Bookstore'
        });
        const button2Text = formatMessage({
            id: 'printcopy.button2',
            defaultMessage: 'Order options'
        });
        return [
            {
                headerText: individual,
                headerIcon: faUser,
                buttonText: button1Text,
                buttonUrl: bookstoreLink
            },
            {
                headerText: bookstore,
                headerIcon: faUsers,
                buttonText: button2Text,
                buttonUrl: 'https://he.kendallhunt.com/sites/default/files/uploadedFiles/Kendall_Hunt/OPENSTAX_PRICE_LIST_and_ORDER_FORM.pdf'
            }
        ];
    }, [formatMessage, bookstoreLink]);
    if (!contentArray) {
        return null;
    }
    return (React.createElement("nav", { className: "order-print-copy" },
        React.createElement(PhoneBoxes, { contentArray }),
        React.createElement(DesktopBoxes, { contentArray })));
}
